import { render, staticRenderFns } from "./centerTop.vue?vue&type=template&id=71277d3e&scoped=true&"
import script from "./centerTop.vue?vue&type=script&lang=js&"
export * from "./centerTop.vue?vue&type=script&lang=js&"
import style0 from "./centerTop.vue?vue&type=style&index=0&id=71277d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71277d3e",
  null
  
)

export default component.exports